import * as React from "react";
import useView from "views/hooks/useView";
import ViewContext from "./ViewContext";
const ViewProvider = ({ children }) => {
  const view = useView();
  return /* @__PURE__ */ React.createElement(ViewContext.Provider, { value: view }, children);
};
export default ViewProvider;
